import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocSideMenu } from 'commons/components/components-wrapper/poc-side-menu.component';
import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const SettingsDevicesConfigurationStyled = styled.div`
    display: flex;
    gap: 24px;
    align-self: center;
    width: 100%;
    max-width: 864px;

    &:first-child {
        flex: 1;
    }

    &:last-child {
        flex: 3;
    }
`;

export const SettingsDevicesConfigurationLeftMenuStyled = styled(PocSideMenu)`
    flex: 1;
    max-width: fit-content;
    height: max-content;
`;

export const SettingsDevicesConfigurationLayoutStyled = styled(PocCard)`
    display: flex;
    flex: 3;
    width: 100%;
    padding: 24px;

    .section-header > .section-title {
        margin-bottom: 16px;
    }
`;

export const SettingsHeaderSections = styled.div`
    display: flex;
    flex-direction: column;

    > .header-title {
        margin-top: 16px;
    }

    > .header-properties {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        align-items: center;
        justify-content: space-between;

        &.is-flex-end-layout {
            align-items: flex-end;
        }

        owc-typography[variant='subtitle1'] {
            color: ${owcTheme['one-color-gray-600']};
        }
    }
`;

export const SectionLoadErrorState = styled.section`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    text-align: center;
`;

export const SettingLayoutContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 16px;
    align-items: end;
    justify-content: end;
`;

export const SettingsLayoutStyledHeader = styled.div`
    top: 0;
    z-index: 10;
    width: 100%;
    padding: 32px 32px 0;
    background-color: #fff;
    border-bottom: 1px solid ${owcTheme['one-color-background-contrast']};

    > .device-info {
        display: flex;
        margin-bottom: 16px;

        > .title {
            display: flex;
            flex-direction: column;

            > div:first-child {
                display: flex;
                gap: 16px;
                align-items: center;
            }

            > owc-typography[variant='body1'] {
                color: ${owcTheme['one-color-interaction-default-intensity-medium']};
            }
        }
    }
`;

export const SettingsConfigurationContent = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    width: 100%;
    padding: 32px;
    background-color: ${owcTheme['one-color-gray-50']};

    > div {
        display: flex;
        justify-content: center;
        width: 100%;

        > div {
            align-items: center;
            width: 100%;
        }
    }
`;

export const DeviceConfiguration = styled(PocCard)`
    width: 100%;
    max-width: 550px;
    padding: 24px;

    /* OWC-OVERRIDE: space the config sections apart. owc-card's content wrapper is a plain
       block with no gap or spacing prop in v7.6.0. */
    > .owc-card__content-wrapper > * {
        margin-bottom: 24px;
    }
`;
